const toggleSponsorBar = (show: boolean) =>
  document
    .querySelector<HTMLElement>('.matches-calendar__container')
    ?.classList.toggle('matches-calendar--hide-sponsor', !show);

const clearEvent = () => {
  window.removeEventListener('scroll', hideSponsorBar);
};

export const hideSponsorBar = () => {
  clearEvent();
  toggleSponsorBar(false);
};

export const showSponsorBar = () => {
  clearEvent();
  toggleSponsorBar(true);
};

export const hideSponsorOnScroll = () => {
  clearEvent();
  window.addEventListener('scroll', hideSponsorBar, { passive: true, once: true });
};
